module.exports = __webpack_public_path__ + "static/a6k-d9204cb75b024731945e58df4d467052.png";